import React from "react";
import { Modal, Button, Radio } from "antd";

const PrintTemplateModal = ({
  open,
  visible,
  onConfirm,
  onCancel,
  templates,
  selectedTemplate,
  setSelectedTemplate,
}) => {
  const isOpen = open ?? visible;
  return (
    <Modal
      open={isOpen}
      title={<span style={{ fontSize: "16px", fontWeight: 600, color: "#1f1f1f" }}>Select Receipt Template</span>}
      onCancel={onCancel}
      footer={
        <div style={{ display: "flex", gap: "8px", justifyContent: "flex-end" }}>
          <Button
            style={{
              height: "36px",
              borderRadius: "6px",
              fontSize: "14px",
              fontWeight: 500,
              border: "1px solid #d9d9d9",
              color: "#333",
              padding: "0 20px",
            }}
            onClick={onCancel}
          >
            Cancel
          </Button>
          <Button
            type="primary"
            style={{
              height: "36px",
              borderRadius: "6px",
              fontSize: "14px",
              fontWeight: 500,
              backgroundColor: "#2d3748",
              borderColor: "#2d3748",
              padding: "0 20px",
            }}
            onClick={onConfirm}
            disabled={!selectedTemplate}
          >
            Print Receipt
          </Button>
        </div>
      }
      centered
      width={480}
      zIndex={1100}
      styles={{ body: { padding: "16px 24px", maxHeight: "400px", overflowY: "auto" } }}
      maskClosable={false}
    >
      <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
        <Radio.Group
          value={selectedTemplate}
          onChange={(e) => {
            setSelectedTemplate(e.target.value);
          }}
          style={{ width: "100%" }}
        >
          <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
            {templates.map((template) => (
              <div
                key={template.cwr_printtemplate_id}
                style={{
                  border: selectedTemplate === template.cwr_printtemplate_id ? "1px solid #2d3748" : "1px solid #e8e8e8",
                  borderRadius: "6px",
                  padding: "12px 14px",
                  cursor: "pointer",
                  backgroundColor: selectedTemplate === template.cwr_printtemplate_id ? "#f7fafc" : "#fff",
                  transition: "all 0.2s ease",
                }}
                onClick={() => {
                  setSelectedTemplate(template.cwr_printtemplate_id);
                }}
              >
                <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                  <Radio value={template.cwr_printtemplate_id} />
                  <span style={{ fontWeight: 500, fontSize: "14px", color: "#1f1f1f" }}>{template.name}</span>
                </div>
              </div>
            ))}
          </div>
        </Radio.Group>
      </div>
    </Modal>
  );
};

export default PrintTemplateModal;
